
// Event ticket
export const _eventTicketClass = {
  name: { type: 'string', title: 'Tapahtuman nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  // Optional reference to customers/{cid}/eventticketgroups. The oneOf options are injected
  // at runtime in EventTicketsContainer.getEnhancedCardSchema, and the FIRST of them is
  // always the empty 'Ei ryhmää' entry - rjsf adopts the first oneOf const as a default when
  // a field has no stored value, so without it every untouched event ticket would be stamped
  // with a group on its next save. See the same guard in schemas/benefitcard.js.
  eventticketgroup: { type: 'string', title: 'Tapahtumaryhmä' },
  start: { type: 'string', format: 'datetime', title: 'Alkuaika' },
  duration: {
    type: 'number',
    title: 'Kesto (minuuteissa)',
    description: 'Tapahtuman kesto minuuteissa. 0 tarkoittaa, että tapahtuman kesto ei tiedossa tai et halua näyttää sitä.',
    default: 0,
  },
  address: {
    type: 'string',
    title: 'Osoite',
    description: 'Tapahtuman osoite. Jätä tyhjäksi, jos tapahtuma ei ole sidottu tiettyyn paikkaan.',
  },
  ticketimage: {
    type: 'string',
    title: 'lippuun tulostettava tapahtuman kuva',
    items: { type: 'object', images: [] },
    minaspectratio: 1,
  },
  ticketsalesstart: {
    type: 'string',
    format: 'datetime',
    title: 'Lippujen myynti alkaa',
    description: 'Aika, jolloin lippujen myynti alkaa. Jätä tyhjäksi, jos myynti alkaa heti.',
  },
  ticketsalesend: {
    type: 'string',
    format: 'datetime',
    title: 'Lippujen myynti päättyy',
    description: 'Aika, jolloin lippujen myynti päättyy. Jätä tyhjäksi, jos myynti päättyy kun tapahtuma alkaa.',
  },
  availableinshop: {
    type: 'string',
    title: 'Näytetäänkö verkkokaupassa',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
    default: 'false',
  },
  showOptionsOnFirstPage: {
    type: 'string',
    title: 'Näytetäänkö lippuvaihtoehdot heti etusivulla asiakasnäkymässä',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
    default: 'false',
  },
  order: {
    type: 'number',
    title: 'Järjestys',
    description: 'Tapahtumien järjestys asiakasnäkymässä. Suurin numero näytetään ensimmäisenä.',
    default: 0,
  },
  instructions: {
    type: 'string',
    title: 'Ohjeet (käytetään ohjeiden tulostukseen pdf lippuun, voit kirjoittaa myös muuta)',
  },
  // Printed once as the last page of the pdf ticket, after every ticket of the order.
  // Empty = no terms page. Rendered server side, see docs/functions-to-update.txt.
  ticketterms: {
    type: 'string',
    title: 'Lippuehdot (tulostetaan pdf-lipun viimeiselle sivulle)',
  },
  hideprintticketheader: {
    type: 'string',
    title: 'Piilota tulostettavan lipun otsikko',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
    default: 'false',
  },
  extrainfo: {
    title: '',
    description: 'Lisätietokysymykset (kysytään asiakkaalta ostettaessa)',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        id: { type: 'string', title: '' },
        title: { type: 'string', title: 'Kysymys' },
        required: { type: 'boolean', title: 'Pakollinen', default: false },
      },
    },
  },
  // type: {
  //   type: 'string',
  //   title: 'Sarjakortin tyyppi',
  //   enum: ['time', 'count'],
  //   enumNames: ['Aikapohjainen', 'Kertapohjainen'],
  // },
  vat: {
    type: 'number',
    title: 'ALV',
    oneOf: [
      { const: 0, title: '0%' },
      { const: 13.5, title: '13,5%' },
      { const: 14, title: '14%' },
      { const: 25.5, title: '25,5%' },
    ],
  },
  variations: {
    title: '',
    description: 'Lippuvaihtoehdot',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        name: { type: 'string', title: 'Nimi' },
        description: { type: 'string', title: 'Kuvaus' },
        section: { type: 'string', title: 'Sektori' },
        price: { type: 'number', title: 'Hinta' },
        earlybirdprice: { type: 'number', title: 'Early bird -hinta' },
        earlybirddeadline: { type: 'string', format: 'date', title: 'Early bird -takaraja' },
        membershipPrices: {
          title: '',
          description: 'Jäsenhinnat',
          type: 'array',
          items: {
            type: 'object',
            properties: {
              membership: { type: 'string', title: 'Jäsenyys' },
              price: { type: 'number', title: 'Hinta' },
            },
          },
        },
        productCode: { type: 'string', title: 'Tuotekoodi' },
        ticketsavailable: {
          type: 'number',
          title: 'Lippuja saatavilla',
          description:
            'Määritä kuinka monta lippua on saatavilla. 0 tarkoittaa, että lippuja ei ole saatavilla.',
          default: 0,
        },
        order: {
          type: 'number',
          title: 'Järjestys',
          description: 'Lippuvaihtoehtojen järjestys asiakasnäkymässä. Suurin numero näytetään ensimmäisenä.',
          default: 0,
        },
        extrainfo: {
          type: 'array',
          title: 'Kysytyt lisätiedot',
          items: { type: 'string' },
        },
        isCombination: {
          type: 'string',
          title: 'Onko tämä yhdistelmälippu (esim. perhelippu)',
          oneOf: [
            { const: 'true', title: 'Kyllä' },
            { const: 'false', title: 'Ei' },
          ],
          default: 'false',
        },
      },
      dependencies: {
        isCombination: {
          oneOf: [
            {
              properties: {
                isCombination: { enum: ['false'] },
                combinations: {
                  title: '',
                  description: 'Kuuluu yhdistelmälippuihin',
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      // The picker is on combinationId: it is the field paymentv3 actually reads,
                      // and storing the NAME here instead used to leave combinationId empty
                      // whenever the name failed to resolve at save time - invisible in the
                      // editor, fatal at payment time. `combination` is kept as a readable copy
                      // of the chosen name, written by firebase.resolveCombinationIds.
                      combinationId: { type: 'string', title: 'Yhdistelmälippu' },
                      combination: { type: 'string', title: '' },
                      quantity: { type: 'number', title: 'Määrä', default: 1 },
                    },
                  },
                },
              },
            },
            {
              properties: {
                isCombination: { enum: ['true'] },
              },
            },
          ],
        },
      },
    },
  },
}
export const _eventTicketClassDeps = {
  // type: {
  //   oneOf: [
  //     {
  //       properties: {
  //         type: {
  //           enum: ['time'],
  //         },
  //         duration: {
  //           type: 'number',
  //           title: 'Kesto (päivää)',
  //         },
  //         createcode: {
  //           type: 'string',
  //           title: 'Luodaanko kortille pääsykoodi? (tukee Digiovea)',
  //           enum: ['true', 'false'],
  //           enumNames: ['Kyllä. Huom! Tukee Digiovea!', 'Ei'],
  //         },
  //         required: ['duration', 'createcode'],
  //       },
  //     },
  //     {
  //       properties: {
  //         type: {
  //           enum: ['count'],
  //         },
  //         count: {
  //           type: 'number',
  //           title: 'Käyntikertojen määrä',
  //         },
  //         required: ['count'],
  //       },
  //     },
  //   ],
  // },
  availableinshop: {
    oneOf: [
      {
        properties: {
          availableinshop: {
            enum: ['true'],
          },
          image: {
            type: 'string',
            title: 'Verkkokaupan tuotekuva',
            items: { type: 'object', images: [] },
            minaspectratio: 1,
          },
          confirmationSubject: {
            type: 'string',
            title: 'Vahvistusviestin otsikko',
          },
          confirmationMessage: {
            type: 'string',
            title: 'Vahvistusviestin sisältö',
          },
          accounting: { type: 'string', title: 'Kirjanpidontili' },
          // validity: {
          //   type: 'string',
          //   title: 'Voimassaoloaika',
          //   enum: ['rolling', 'next', 'fixed', 'permanent'],
          //   enumNames: ['Rullaava ajanjakso', 'Seuraavaan ajanjaksoon', 'Kiinteä ajanjakso', 'Pysyvä'],
          // },
          // validityperiod: {
          //   type: 'number',
          //   title: 'Voimassaoloaika päivinä ostohetkestä (0 = ei päättymistä)',
          // },
          // validfrom: {
          //   type: 'string',
          //   title: 'Voimassaolo alkaa, jätä tyhjäksi jos alkaa ostohetkestä',
          //   format: 'date',
          // },
          // validuntil: {
          //   type: 'string',
          //   title: 'Voimassaolo päättyy, jos voimassa oloaika on asetettu se kumpi on aiemmin määrää',
          //   format: 'date',
          // },
        },
      },
      {
        properties: {
          availableinshop: {
            enum: ['false'],
          },
        },
      },
    ],
  },
}

export const _eventTicketUISchema = {
  description: {
    'ui:widget': 'editorWidget',
  },
  confirmationMessage: {
    'ui:widget': 'editorWidget',
  },
  image: {
    'ui:widget': 'imageWidget',
  },
  ticketimage: {
    'ui:widget': 'imageWidget',
  },
  vat: {
    'ui:enumDisabled': [14],
  },
  instructions: {
    'ui:widget': 'editorWidget',
  },
  ticketterms: {
    'ui:widget': 'editorWidget',
    'ui:help': 'Jätä tyhjäksi, jos ehtosivua ei tarvita.',
  },
  extrainfo: {
    items: {
      id: { 'ui:widget': 'hidden' },
    },
  },
  variations: {
    items: {
      combinations: {
        items: {
          combinationId: { 'ui:widget': 'combinationVariationWidget' },
          combination: { 'ui:widget': 'hidden' },
        },
      },
      extrainfo: { 'ui:field': 'extraInfoSelectField' },
    },
  },
}
